import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './event-meta.module.scss';


import VenueLabel from '../venue-label/venue-label';

const EventMeta = ({ venue, venueLink, series, cost, className }) => {
  const classes = classnames(styles.meta, className);
  return (
    <div className={classes}>
      {series && (
        <p>
          <b>Series:</b> {series}
        </p>
      )}
      {venue && (
        <span>
          <VenueLabel venue={venue} path={venueLink} />
        </span>

      )}
      {cost && (
        <p>
          <b>Cost:</b> {cost}
        </p>
      )}
    </div>
  );
};

EventMeta.propTypes = {
  className: PropTypes.string,
  cost: PropTypes.string,
  series: PropTypes.string,
  venue: PropTypes.string,
  venueLink: PropTypes.string
};

export default EventMeta;
